/* eslint-disable */
import MediaMatcher from 'lib/media-matcher';

function extend(...args) {
  for (let i = 1; i < args.length; i++) {
    for (const key in args[i]) {
      if (args[i].hasOwnProperty(key)) {
        if (typeof args[0][key] === 'object'
                  && typeof args[i][key] === 'object') extend(args[0][key], args[i][key]);
        else args[0][key] = args[i][key];
      }
    }
  }
  return args[0];
}

/*
    JavaScript flexImages v1.0.2
    Copyright (c) 2014 Simon Steinberger / Pixabay
    GitHub: https://github.com/Pixabay/JavaScript-flexImages
    License: http://www.opensource.org/licenses/mit-license.php
    Converted to Typescript and IE support removed 8-23-2021
*/

type GridSelector = string | HTMLElement

type GridOptions = {
  container?:string,
  disableMaxWidth?:boolean | null,
  margin?:number
  maxRows?:number,
  object?:string,
  rowHeight?:number,
  selector?:GridSelector
  truncate?:number,
}

const flexImages = (function () {
  // "use strict";
  function flexImages(options:GridOptions) {
    if (!document.querySelector) return;

    function makeGrid({
      grid,
      items,
      o,
      noresize = null
    }:{ grid:HTMLElement, items:HTMLElement[], o:GridOptions, noresize?:boolean}) {
      let x; let new_w; let exact_w; let h;
      let ratio = 1;
      let rows = 1;
      const max_w = grid.clientWidth - 2;
      let row = [];
      let row_width = 0;
      let row_h = o.rowHeight;

      // define inside makeGrid to access variables in scope
      function _helper(lastRow = null) {
        if (o.maxRows && rows > o.maxRows || o.truncate && lastRow && rows > 1) row[x][0].style.display = 'none';
        else {
          if (row[x][4]) { row[x][3].setAttribute('src', row[x][4]); row[x][4] = ''; }
          row[x][0].style.width = `${new_w}px`;
          row[x][0].style.height = `${row_h}px`;
          row[x][0].style.display = 'block';
        }
      }

      for (let i = 0; i < items.length; i++) {
        row.push(items[i]);
        row_width += items[i][2] + o.margin;

        if (row_width >= max_w) {
          const margins_in_row = row.length * o.margin;
          ratio = (max_w - margins_in_row) / (row_width - margins_in_row), row_h = Math.ceil(o.rowHeight * ratio), exact_w = 0, new_w;
          
          for (x = 0; x < row.length; x++) {
            new_w = Math.ceil(row[x][2] * ratio);
            exact_w += new_w + o.margin;
            if (exact_w > max_w) new_w -= exact_w - max_w;
            _helper();
          }

          // reset for next row
          row = [], row_width = 0;
          rows++;
        }
      }

      // layout last row - match height of last row to previous row
      for (x = 0; x < row.length; x++) {
        new_w = Math.floor(row[x][2] * ratio), h = Math.floor(o.rowHeight * ratio);
        _helper(true);
      }

      // scroll bars added or removed during rendering new layout?
      if (!noresize && max_w != grid.clientWidth) makeGrid({ grid, items, o, noresize: true });
    }

    const o:GridOptions = {
      selector: null, container: '.item', object: 'img', rowHeight: 180, maxRows: 0, truncate: 0,
    };

    for (const k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }

    const grids = typeof o.selector === 'object' ? [o.selector] : document.querySelectorAll(o.selector);

    for (let i = 0; i < grids.length; i++) {
      var grid = grids[i] as HTMLElement;
      const containers = Array.from(grid.querySelectorAll(o.container)) as Element[];
      var items = [];
      const t = new Date().getTime();

      if (!containers.length) continue;

      const s = getComputedStyle(containers[0], null);
      
      o.margin = (parseInt(s.marginLeft) || 0) + (parseInt(s.marginRight) || 0) + (Math.round(parseFloat(s.borderLeftWidth)) || 0) + (Math.round(parseFloat(s.borderRightWidth)) || 0);

      for (let j = 0; j < containers.length; j++) {
        const c = containers[j];
        const w = parseInt(c.getAttribute('data-w'));
        const norm_w = w * (o.rowHeight / parseInt(c.getAttribute('data-h'))); // normalized width
        const obj = c.querySelector(o.object);
        items.push([c, w, norm_w, obj, obj.getAttribute('data-src')]);
      }

      makeGrid({ grid, items, o });

      const tempf = function () { makeGrid({ grid, items, o }); };

      window[`flexImages_listener${t}`] = tempf;
      window.removeEventListener('resize', window[`flexImages_listener${grid.getAttribute('data-flex-t')}`]);
      delete window[`flexImages_listener${grid.getAttribute('data-flex-t')}`];
      window.addEventListener('resize', window[`flexImages_listener${t}`]);

      grid.setAttribute('data-flex-t', t.toString());
    }
  }
  return flexImages;
}());

declare global {
  interface Window {
    flexImages:any
    ezResourceGrid:any
  }
}

(function () {
  window.flexImages = flexImages;
}());

/* eslint-enable */

export default function ezResourceGrid({
  gridSelector,
  options,
  callback = null,
}:{ gridSelector:HTMLElement, options:GridOptions, callback:() => void}) {
  const gridOptions = extend({
    container: '.ez-resource-grid__item',
    disableMaxWidth: null,
    maxRows: 0,
    object: 'img',
    rowHeight: 180,
    selector: gridSelector,
    truncate: 0,
  }, options);

  const gridItems = gridSelector.querySelectorAll('li');

  const initMobileGrid = () => {
    gridSelector.classList.add('mobile-disabled');

    if (gridItems.length) gridSelector.classList.remove('is-hidden');
  };

  const initFlexGrid = () => {
    gridSelector.classList.remove('mobile-disabled');

    window.flexImages(gridOptions);

    if (gridItems.length) gridSelector.classList.remove('is-hidden');
    if (callback) callback();
  };

  if (gridOptions.disableMaxWidth) {
    const mediaMatcher = new MediaMatcher();

    mediaMatcher.addMediaQuery(`(max-width: ${gridOptions.disableMaxWidth}px)`,
      () => { initMobileGrid(); },
      () => { initFlexGrid(); });

    mediaMatcher.evaluateAll();
    mediaMatcher.addListeners();

    document.addEventListener('turbolinks:before-visit', () => {
      mediaMatcher.removeListeners();
      mediaMatcher.clearQueries();
    }, { once: true });
  } else {
    initFlexGrid();
  }
}

window.ezResourceGrid = ezResourceGrid;
